'use client';

import { c as _c } from "react/compiler-runtime";
import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
const MenuCover = t0 => {
  const $ = _c(7);
  const {
    coverVisible,
    close
  } = t0;
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = `fixed overscroll-none z-40 transition-opacity duration-300 ease-in-out bg-menu-overlay top-[var(--header-height)] lg:top-0 bottom-0 left-0 right-0 ${coverVisible ? "visible opacity-100" : "hidden invisible opacity-0 pointer-events-none"}`;
  let t4;
  if ($[2] !== close || $[3] !== t3) {
    t4 = <div onClick={close} aria-hidden="true" className={t3} />;
    $[2] = close;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const overlay = t4;
  if (mounted) {
    let t5;
    if ($[5] !== overlay) {
      t5 = createPortal(overlay, document.body);
      $[5] = overlay;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  return null;
};
export default MenuCover;